import { API, BACKEND_URL } from '@/config/api';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/App';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  
  useEffect(() => {
    const handleAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');
      
      if (!sessionId) {
        toast.error('Ingen session ID funnet');
        navigate('/');
        return;
      }
      
      try {
        // Exchange session_id for session_token
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        // Store session_token in cookie (done by backend)
        const sessionToken = response.data.session_token;
        
        // Set cookie manually as backup
        document.cookie = `session_token=${sessionToken}; path=/; max-age=${7 * 24 * 60 * 60}; samesite=lax`;
        
        // Refresh auth state
        await checkAuth();
        
        // Redirect based on user role
        navigate('/admin');
        
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Autentisering feilet');
        navigate('/');
      }
    };
    
    handleAuth();
  }, [navigate, checkAuth]);
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 via-teal-50 to-blue-50">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Autentiserer...</p>
      </div>
    </div>
  );
}